import React, { useRef, useState, useEffect } from 'react';
import './LoupeView.css';

function LoupeView({ path1, path2 }) {
  const containerRef = useRef(null);      // Conteneur global
  const baseImageRef = useRef(null);      // Référence à l'<img> de la 1ère image
  const [mousePos, setMousePos] = useState({ x: 0, y: 0 });
  const [isHovering, setIsHovering] = useState(false);

  // Dimensions réelles de l'image 1 sur l'écran (en px)
  const [baseImageSize, setBaseImageSize] = useState({ width: 0, height: 0 });

  const [lensDiameter, setLensDiameter] = useState(120);

  useEffect(() => {
    // Mesure la taille finale de l'image 1 après chargement
    function handleImgLoad() {
      if (baseImageRef.current) {
        setBaseImageSize({
          width: baseImageRef.current.clientWidth,
          height: baseImageRef.current.clientHeight
        });
      }
    }
    // On écoute l'événement onload de l'<img>
    const imgElem = baseImageRef.current;
    if (imgElem && imgElem.complete) {
      handleImgLoad();
    } else if (imgElem) {
      imgElem.addEventListener('load', handleImgLoad);
      return () => {
        imgElem.removeEventListener('load', handleImgLoad);
      };
    }
  }, []);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    function handleMouseMove(e) {
      const rect = container.getBoundingClientRect();
      const x = e.clientX - rect.left;
      const y = e.clientY - rect.top;

      // On borne pour empêcher la loupe de sortir
      const half = lensDiameter / 2;
      let clampedX = Math.max(half, Math.min(x, rect.width - half));
      let clampedY = Math.max(half, Math.min(y, rect.height - half));

      setMousePos({ x: clampedX, y: clampedY });
    }

    function handleMouseEnter() {
      setIsHovering(true);
    }
    function handleMouseLeave() {
      setIsHovering(false);
    }

    container.addEventListener('mousemove', handleMouseMove);
    container.addEventListener('mouseenter', handleMouseEnter);
    container.addEventListener('mouseleave', handleMouseLeave);

    return () => {
      container.removeEventListener('mousemove', handleMouseMove);
      container.removeEventListener('mouseenter', handleMouseEnter);
      container.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, [lensDiameter]);

  useEffect(() => {
    const handleKeyDown = (e) => {
      // + ou = => on augmente le diam de 10 px, maximum 400 px 
      if (e.key === '+') {
        e.preventDefault();
        setLensDiameter((prev) => Math.min(550, prev + 10));
      }
      // - => on diminue le diam de 10 px, minimum 40 px 
      if (e.key === '-') {
        e.preventDefault();
        setLensDiameter((prev) => Math.max(40, prev - 10));
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, []);

  // Calcule la position du background pour la 2ème image
  const offset = -4; // Ajustement fin du décalage
  const backgroundPosX = -(mousePos.x - lensDiameter / 2 - offset);
  const backgroundPosY = -(mousePos.y - lensDiameter / 2);

  return (
    <div className="container-fluid d-flex justify-content-center align-items-center">
      <div className="loupe-container" ref={containerRef} style={{ maxWidth: '550px' }}>
        <img 
          ref={baseImageRef}
          src={path1} 
          alt="Image 1" 
          className="base-image"
          style={{
            maxWidth: '550px',
            width: '100%',
            height: 'auto',
            objectFit: 'contain'
          }}
        />
  
        {isHovering && baseImageSize.width > 0 && baseImageSize.height > 0 && (
          <div
            className="loupe-lens"
            style={{
              width: `${lensDiameter}px`,
              height: `${lensDiameter}px`,
              left: `${mousePos.x - lensDiameter / 2}px`,
              top:  `${mousePos.y - lensDiameter / 2}px`,
              backgroundImage: `url(${path2})`,
              backgroundPosition: `${backgroundPosX}px ${backgroundPosY}px`,
              backgroundSize: `${baseImageSize.width}px ${baseImageSize.height}px`,
              transform: 'none',  // Ajout pour maintenir l'échelle
            }}
          />
        )}
      </div>
    </div>
  );
}

export default LoupeView;
